import { render } from "./SchoolProjects.vue?vue&type=template&id=a9ff30d8"
import script from "./SchoolProjects.vue?vue&type=script&lang=js"
export * from "./SchoolProjects.vue?vue&type=script&lang=js"
script.render = render

export default script